import { createContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { responseInterceptor } from "../api/axios";
import { useMsal } from "@azure/msal-react";

import useCookie from "../hooks/useCookie";
import axios from "../api/axios";
import config from '../config/configJS';

const AuthContext = createContext({});

export const AuthProvider = ({children}) => {

    const { instance } = useMsal();
    const navigate = useNavigate();
    const location = useLocation();

    const [working, setWorking] = useState(true);
    const [auth, setAuth] = useState({});    

    const [ulaCookie, setUlaCookie] = useCookie("ULA");
    const [ustCookie, setUstCookie] = useCookie("UST");

    const [userType, setUserTypeState] = useState(() => {
        return ustCookie ? JSON.parse(ustCookie) : null;
    })

    const [userLang, setUserLangState] = useState(() => {
        return ulaCookie ? JSON.parse(ulaCookie) : null;
    })

    const setUserType = (type) => {
        setUserTypeState(type); 
        setUstCookie("UST", JSON.stringify(type)); 
    };

    const setUserLang = (lang) => {
        setUserLangState(lang);
        setUlaCookie("ULA", JSON.stringify(lang));
    }

    const refresh = async () => {
        setWorking(true);
        try {         
            const response = await axios.post('/api/auth/GetUserByCookie', {}, {
                withCredentials: true
            });

            if (response.status === 200) {
                setAuth({
                    uid: response.data.id,
                    ufn: response.data.userFirstname,
                    uln: response.data.userLastname,
                    uem: response.data.userEmail,
                    uia: response.data.isActive,
                    uri: response.data.roleId
                });    

                setWorking(false);    
            }

        } catch (refreshError) {
            setWorking(false);         
        }
        setWorking(false);
    };

    const logoutUser = () => {
        axios.post(config.endPoint + "/api/auth/LogOut", {}, {
            withCredentials: true
        })
        .then(async () => {
            if (!!instance) {
                console.log('logging out');
                await instance.logout();
            }
            setWorking(true);
            navigate('/Login');
        })
        .catch((error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        if (!auth.uid) {                       
            setWorking(true);
            axios.interceptors.response.eject(responseInterceptor);
            refresh();
        }   
    },[]); 

    useEffect(() => {
        if (ustCookie && !userType) {
            setUserType(JSON.parse(ustCookie));  
        }
    }, [ustCookie, userType]);

    useEffect(() => {
        if (ulaCookie && !userLang) {
            setUserLang(JSON.parse(ulaCookie));  
        }
    }, [ulaCookie, userLang]);

    return (
        <AuthContext.Provider value={{ 
                auth, setAuth, 
                userType, setUserType, 
                userLang, setUserLang 
        }}>
            {!working ? children : null }
        </AuthContext.Provider>
    );
};

export default AuthContext;